import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { SessionStorageService } from "./session-storage.service";

// Para utilizar o breadcrumb basta injetar o serviço em um componente
// e usar a função addBreadcrumb passando o nome a ser exibido como
// parâmetro.

// Não é necessário adicionar a rota da vitrine, pois esta é adicionata
// no constructor, caso o fluxo não seja iniciado pela vitrine.

@Injectable()
export class BreadcrumbService {
    private _breadcrumbTrail: BreadcrumbItemInterface[] = [];

    public onBreadcrumbTrailChanged: Subject<BreadcrumbItemInterface[]> = new Subject<BreadcrumbItemInterface[]>();
    public onDisable: Subject<boolean> = new Subject<boolean>();

    constructor (
        private router: Router,
        private sessionStorageService: SessionStorageService
    ) {
        this.init();
    }

    private init() {
        const shopWindowRoute = this.sessionStorageService.getShopWindowRoute();
        const sessionStorageBreadcrumbTrail = this.sessionStorageService.getBreadCrumbTrail();

        // if (!shopWindowRoute) return;
        // if (sessionStorageBreadcrumbTrail) {
        //     const currentRoute = this.router.url;
        //     const path = currentRoute.split("/").pop();

        //     if (sessionStorageBreadcrumbTrail.pop().path === path) {
        //         this.setBreadcrumbTrail(sessionStorageBreadcrumbTrail);
        //         return;
        //     }
        // }
        
        // if (shopWindowRoute === 'upgrade') {
        //     return;
        // }

        const label = shopWindowRoute === "meu-plano" ? "Planos" : shopWindowRoute === "meu-pacote"?"Pacotes":null;
        this.addBreadcrumb(label, shopWindowRoute);
    }   

    public addBreadcrumb(label: string, optionalPath?: string) {
        const currentRoute = this.router.url;
        const path = optionalPath || currentRoute.split("/").pop();
        const breadcrumb: BreadcrumbItemInterface = {
            label: label,
            path: path
        };

        if (this._breadcrumbTrail.find(b => compareBreadbcrumb(breadcrumb, b))) return;
        
        this._breadcrumbTrail.push(breadcrumb);
        this.onBreadcrumbTrailChanged.next(this._breadcrumbTrail);
        this.sessionStorageService.setBreadcrumbTrail(this._breadcrumbTrail);
    }

    public disableBreadcrumb(): void {
        this.onDisable.next(true);
    }

    public enableBreadcrumb(): void {
        this.onDisable.next(false);
    }
    
    public setBreadcrumbTrail(trail: BreadcrumbItemInterface[]) {
        this._breadcrumbTrail = trail;

        this.onBreadcrumbTrailChanged.next(this._breadcrumbTrail);
    }

    public get breadCrumbTrail(): BreadcrumbItemInterface[] {
        return this._breadcrumbTrail;
    }
}

export interface BreadcrumbItemInterface {
    path: string;
    label: string;
}

function compareBreadbcrumb(a: BreadcrumbItemInterface, b: BreadcrumbItemInterface): boolean {
    return a.label === b.label || a.path === b.path;
}